import { transition } from '@helpers/animate';
import { siteWide } from '@helpers/grid';
import { Layers } from '@helpers/layers';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Container = styled.div `
  ${siteWide};

  position: relative;
  height: 0;
  z-index: -1;

  &:focus-within {
    z-index: ${Layers.Navigation + 1};
  }

  ${ButtonStyles.Container} {
    ${transition('opacity, transform')};

    opacity: 0;
    transform: translate(3px, -100%);

    &:focus-visible,
    &.focus-ring {
      opacity: 1;
      transform: translate(3px, 3px);
    }
  }
`;
const SkipLinkStyles = {
    Container,
};
export default SkipLinkStyles;
